import { mxCylinder , mxConnectionConstraint , mxPoint, mxConstants} from "../utils/graph/mxModule";

function nmosStickShape() {}
nmosStickShape.prototype = new mxCylinder();
nmosStickShape.prototype.constructor = nmosStickShape;

// Port positions relative to the 120×70 vertex (the actual placed size).
// innerW=100, innerH=50 fixed → S at x=35/120, D at x=85/120, both at y=0.5
// G_top and G_bottom are the same electrical node (gate poly endpoints).
nmosStickShape.config = {
  width: 70,
  height: 70,
  ports: [
    { name: "G", label: "", x: 0.5,              y: 0   }, // top of gate poly
    { name: "G", label: "", x: 0.5,              y: 1   }, // bottom of gate poly (same node)
    { name: "S", label: "", x: 0,         y: 0.5 },
    { name: "D", label: "", x: 1,         y: 0.5 },
  ],
};

nmosStickShape.prototype.paintVertexShape = function (c, x, y, w, h) {
  const style = this.style || {};
  const isFlipped = style.flipH === 1 || style.flipH === "1" || style[mxConstants.STYLE_FLIPH] === 1;
  const circleColor = style.circleColor || '#000000';
  const labelColor = style.fontColor || style.circleColor || '#000000';

  const symbolSpec = { width: 200, height: 150 };
  const dx = w / symbolSpec.width;
  const dy = h / symbolSpec.height;
  const px = v => v * dx;
  const py = v => v * dy;

  c.setFillColor('none');
  c.setStrokeColor('none');
  c.rect(x, y, w, h);
  c.fillAndStroke();

  const midX = x + w / 2;

  const innerW = 70;
  const innerH = 70;
  const innerX = x + (w - innerW) / 2;
  const innerY = y + (h - innerH) / 2;

  // Orange rectangle (active region)
  c.setStrokeColor('#FF5733');
  c.begin();
  c.rect(innerX, innerY, innerW, innerH);
  c.stroke();

  // Green line (diffusion)
  c.setStrokeColor('#21b04c');
  c.setStrokeWidth(3); 
  c.begin();
  c.moveTo(innerX, innerY + innerH / 2);
  c.lineTo(innerX + innerW, innerY + innerH / 2);
  c.stroke();

  // Red line (gate poly, vertical)
  c.setStrokeColor('#ed1c24');
  c.setStrokeWidth(3); 
  c.begin();
  c.moveTo(midX, y);
  c.lineTo(midX, y + h);
  c.stroke();

  // Connection-point dots at port positions
  const radius = 3;
  c.setFillColor(circleColor);
  c.setStrokeColor(circleColor);

  // S and D port labels painted directly on the shape (not cell values)
  // Positioned just above the child port ellipses at (35/120)*w and (85/120)*w
  const sX = isFlipped ? x + w : x;  
  const dX = isFlipped ? x : x + w;       
  const portY = y + 0.5 * h - 10;
  c.setFontColor(labelColor);
  c.setFontSize(9 / this.scale);
  c.text(sX+5, portY, 0, 0, 'S', 'center', 'middle', 0, 'html', 0, 0, 0, 'ltr');
  c.text(dX+5, portY, 0, 0, 'D', 'center', 'middle', 0, 'html', 0, 0, 0, 'ltr');
};

export default nmosStickShape;
